import { render, staticRenderFns } from "./Referrals.vue?vue&type=template&id=4a6b8f22&"
import script from "./Referrals.vue?vue&type=script&lang=ts&"
export * from "./Referrals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports